<template>
  <div class="workcenter-list-card" :class="cardClasses" @click="handleClick" @contextmenu.prevent="$emit('contextmenu', $event, item)">
    <div class="workcenter-list-card__top">
      <div class="workcenter-list-card__title-wrap">
        <i :class="[icon, iconClass]"></i>
        <span class="workcenter-list-card__title">{{ title }}</span>
      </div>
      <span class="workcenter-list-card__date">{{ dateLabel }}</span>
    </div>
    <div class="workcenter-list-card__meta">
      <span v-if="jobNumber" class="workcenter-list-card__job">{{ jobNumber }}</span>
      <span v-if="tag && tag.toLowerCase() !== 'none'" class="workcenter-list-card__tag" :class="tagClass">{{ tag }}</span>
    </div>
    <p class="workcenter-list-card__message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'WorkcenterCard',
  props: {
    item: { type: Object, required: true },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    dateLabel: { type: String, default: '' },
    jobNumber: { type: String, default: '' },
    tag: { type: String, default: '' },
    tagColor: { type: String, default: 'red' },
    icon: { type: String, default: 'bx bx-envelope' },
    unread: { type: Boolean, default: false }
  },
  computed: {
    iconClass() {
      return this.unread ? 'workcenter-list-card__icon--unread' : 'workcenter-list-card__icon--read'
    },
    tagClass() {
      return 'workcenter-list-card__tag--' + this.tagColor
    },
    cardClasses() {
      return {
        'workcenter-list-card--unread': this.unread,
        ['workcenter-list-card--' + this.tagColor]: !!this.tag
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.item)
    }
  }
}
</script>
